import Vue, { CreateElement } from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'AboutApartmentOptionsItem',
})
export default class AboutApartmentOptionsItem extends Vue {
  @Prop({type: String, default: '' }) public readonly label!: string;
  @Prop({type: Boolean, default: false }) public readonly isMobile!: boolean;

  private render(createElement: CreateElement) {
    return createElement('div',
      { class: [
        'options-item',
        this.isMobile && 'mobile',
        ],
      },
    [
      createElement('span'),
      createElement('p', { class: 'p3'}, this.label),
    ]);
  }
}
